<!-- require user interaction for switching an Dom offer to an LLD or other when already one into cart -->
<template>
  <div class="modal fade slide-right" id="ChangeOfferModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" ref="modal">
      <div class="modal-dialog modal-sm">
          <div class="modal-content-wrapper">
              <div class="modal-content">
                  <div class="modal-header clearfix text-left">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        <i class="pg-close fs-14"></i>
                      </button>
                      <h5> Une offre d'un type incompatible existe déjà dans votre panier, souhaitez vous l'écraser ?
                      </h5>
                  </div>
                  <div class="modal-body"  >
                        <!-- <resource-form :model="form.model" :schema="form.schema" :triggers="form.triggers" :submit-button='false' :hub='hub' :dropdownParent="'#mainifyModal'"
                        >
                        </resource-form> -->
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-primary btn-cons pull-left inline" data-dismiss="modal" @click="$emit('confirm', {offer:newoffer, active_cart:active_cart})" >
                          Confirmer
                      </button>
                      <button type="button" class="btn btn-default btn-cons no-margin pull-left inline"
                              data-dismiss="modal" @click="$emit('cancel')">Annuler
                      </button>
                  </div>
              </div>
          </div>
          <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
  </div>
</template>

<script>
// TODO :
    // DISPLAY THE MODAL WHEN A CRUSH CART EVENT IS RAISED
    // RETREIVE THE OFFER DATA
    // CRUSH THE INCOMPATIBLE OFFER FROM THE CART
      // REMOVING IT FROM CART
      // ADDING THE NEW ONE
      // SHowmaninify modal system
      //

export default {

  mounted () {
      $(this.$el).modal()
      // this.hub.$on("my-submit", (model) => {
      //   this.$emit('mainify', this.newMainRepresentative.representative_id, model)
      // })
  },

  beforeDestroy () {
      // this.hub.$off("submit")
      $(this.$el).modal('hide')
      $('body').removeClass('modal-open')
      $('.modal-backdrop').remove()
  },

  props:["newoffer", "active_cart"],

}

</script>

<style>
</style>



// WEBPACK FOOTER //
// client/components/Catalog/ChangeOfferModal.vue